import { RequestBodyElement } from '@swagger-api/apidom-ns-openapi-3-0';
class RequestBody extends RequestBodyElement {}
export default RequestBody;